const API_BASE_URL = (
  process.env.REACT_APP_ANINA_AUTH_API_URL || "http://localhost:8000"
).replace(/\/$/, "");

const CSRF_INTENT = "anina-auth-v1";

async function readJson(response) {
  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const detail = payload?.detail;
    const message =
      typeof detail === "string"
        ? detail
        : detail?.message || "AI Assistant request failed.";

    throw new Error(message);
  }

  return payload;
}

async function ninaRequest(path, options = {}) {
  const method = options.method || "GET";
  const mutation = method !== "GET";

  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: "include",
    ...options,
    headers: {
      Accept: "application/json",
      ...(mutation
        ? {
            "Content-Type": "application/json",
            "X-CSRF-Intent": CSRF_INTENT,
          }
        : {}),
      ...(options.headers || {}),
    },
  });

  return readJson(response);
}

export function listNinaConversations() {
  return ninaRequest("/nina/conversations");
}

export function createNinaConversation(title = null) {
  return ninaRequest("/nina/conversations", {
    method: "POST",
    body: JSON.stringify({ title }),
  });
}

export function listNinaMessages(conversationId) {
  return ninaRequest(
    `/nina/conversations/${encodeURIComponent(conversationId)}/messages`,
  );
}

export function createNinaUserMessage(conversationId, content) {
  return ninaRequest(
    `/nina/conversations/${encodeURIComponent(conversationId)}/messages`,
    {
      method: "POST",
      body: JSON.stringify({ content }),
    },
  );
}

export function createNinaAssistantResponse(conversationId) {
  return ninaRequest(
    `/nina/conversations/${encodeURIComponent(conversationId)}/responses`,
    {
      method: "POST",
    },
  );
}
